import { JSX, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckRounded, Close } from '@mui/icons-material';
import { Button, Dialog, IconButton, Typography } from '@mui/material';
import OrganisationTreeNode from 'shared/features/organisation/models/organisation-tree-node';

import OrganisationTree from 'features/organisation/views/organisation-tree/organisation-tree.component';

import './organisation-picker.scss';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onOrganisationUnitSelected: (selectedNode: OrganisationTreeNode, upstreamParentBranch: OrganisationTreeNode[]) => void;
  sessionStorageKey?: string;
}

const OrganisationPicker = (props: Readonly<IProps>): JSX.Element => {
  const { t } = useTranslation('organisation');

  const [selectedNode, setSelectedNode] = useState<OrganisationTreeNode | undefined>();
  const [upstreamParentBranch, setUpstreamParentBranch] = useState<OrganisationTreeNode[]>([]);

  const onSelectOrganisationUnit = (selectedNode: OrganisationTreeNode | undefined, upstreamParentBranch: OrganisationTreeNode[]): void => {
    setSelectedNode(selectedNode);
    setUpstreamParentBranch(upstreamParentBranch);
  };

  const onDeselectOrganisationUnit = (): void => {
    onSelectOrganisationUnit(undefined, []);
  };

  const handleSelect = (): void => {
    if (!selectedNode) {
      return;
    }

    props.onOrganisationUnitSelected(selectedNode, upstreamParentBranch);
  };

  return (
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
      className="organisation-picker"
      slotProps={{
        paper: {
          className: 'organisation-picker-paper',
        },
      }}
    >
      <div className="organisation-picker-header" data-testid="organisationPicker">
        <Typography variant="h2">{t('picker.title')}</Typography>
        <Button
          startIcon={<CheckRounded />}
          variant="contained"
          disabled={!selectedNode}
          onClick={handleSelect}
          data-testid="organisationPickerSelectButton"
        >
          {t('picker.selectButton')}
        </Button>
        <IconButton aria-label="close" className="close-button" onClick={props.onClose} data-testid="organisationPickerCloseButton">
          <Close />
        </IconButton>
      </div>
      <OrganisationTree
        sessionStorageKey={props.sessionStorageKey}
        onSelectOrganisationUnit={onSelectOrganisationUnit}
        onDeselectOrganisationUnit={onDeselectOrganisationUnit}
      />
    </Dialog>
  );
};

export default OrganisationPicker;
